<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <h1>Video zu Roodie</h1>
        <div class="c-iframe ion-margin-vertical">
          <div class="c-iframe__wrapper">
            <iframe
              id="video"
              class="c-iframe__video"
              width="560"
              height="315"
              src="https://player.vimeo.com/video/601096133"
              title="Vimeo video player"
              frameborder="0"
              allow="autoplay"
              allowfullscreen
              webkitallowfullscreen
              mozallowfullscreen
            ></iframe>
          </div>
        </div>
        <!-- <div class="ion-text-center">
          <img src="@/assets/img/video-mock.png" class="ion-margin-vertical" />
        </div> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonButtons,
  IonContent,
  //   IonList,
  // IonListHeader,
  //   IonItem,
  //   IonLabel,
  // IonNote,
  IonButton,
  IonIcon,
  //   IonText,
  IonGrid,
  IonBackButton,
  //   IonRow,
  //   IonCol,
} from "@ionic/vue";

import { chevronBack } from "ionicons/icons";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonButtons,
    IonContent,
    // IonList,
    // IonListHeader,
    // IonItem,
    // IonLabel,
    // IonNote,
    IonButton,
    IonIcon,
    // IonText,
    IonGrid,
    IonBackButton,
    // IonRow,
    // IonCol,
  },
  methods: {},
  setup() {
    return { chevronBack };
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
